import { ApiError } from "@/api/client";
import { fetchFormsList } from "@/api/forms";
import type { FormListItemDto } from "@/types/formList";

const FORMS_FETCH_PAGE_SIZE = 100;

export type LoadFormsListOptions = {
  syncYandex?: boolean;
  organisationId?: number;
  unassignedOnly?: boolean;
  serviceOnly?: boolean;
  excludeServiceForms?: boolean;
};

async function fetchAllFormPages(
  options: LoadFormsListOptions,
): Promise<FormListItemDto[]> {
  const first = await fetchFormsList({
    page: 1,
    count: FORMS_FETCH_PAGE_SIZE,
    syncYandex: options.syncYandex,
    organisationId: options.organisationId,
  });
  const items = [...(first.data ?? [])];
  const lastPage = first.meta?.last_page ?? 1;

  for (let page = 2; page <= lastPage; page += 1) {
    const response = await fetchFormsList({
      page,
      count: FORMS_FETCH_PAGE_SIZE,
      organisationId: options.organisationId,
    });
    items.push(...(response.data ?? []));
  }

  if (options.serviceOnly) {
    return items.filter((form) => form.isServiceForm === true);
  }
  if (options.unassignedOnly) {
    return items.filter(
      (form) => form.organisationId == null && !form.isServiceForm,
    );
  }
  if (options.excludeServiceForms) {
    return items.filter((form) => !form.isServiceForm);
  }
  return items;
}

export async function loadAllForms(
  options: LoadFormsListOptions,
): Promise<FormListItemDto[]> {
  try {
    return await fetchAllFormPages(options);
  } catch (err) {
    if (
      options.syncYandex &&
      err instanceof ApiError &&
      err.status >= 500
    ) {
      return fetchAllFormPages({ ...options, syncYandex: false });
    }
    throw err;
  }
}
